import { reactSelectBuiltins } from '@liveauctioneers/hammer-ui-core/select';
import { ComponentProps } from 'react';
import styled from 'styled-components';

const Input = (props: ComponentProps<typeof reactSelectBuiltins.Input>) => (
    <SelectNumberInputContainer>
        <reactSelectBuiltins.Input
            {...props}
            pattern="\d*"
            type="number"
        />
    </SelectNumberInputContainer>
);

export default Input;

// Remove up/down buttons from number input
const SelectNumberInputContainer = styled.span`
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
    /* Firefox */
    input[type='number'] {
        /* stylelint-disable-next-line property-no-vendor-prefix */
        -moz-appearance: textfield;
    }

    /* Chrome, Safari, Edge, Opera */
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
        /* stylelint-disable-next-line property-no-vendor-prefix */
        -webkit-appearance: none;
        margin: 0;
    }
`;
